'use client'

import React from 'react'

import { Icon, Logo } from 'components/ui'
import { ActiveLink } from 'components/navigation'
import Navigation from 'compositions/Navigation/Navigation'
import LiveSwitcher from 'compositions/LiveSwitcher/LiveSwitcher'


const LeftSidebar: React.FC = () => {
  return (
    <div className="h-full">
      <div className="px-4 py-5 sticky top-0 flex items-center justify-between">
        <Logo className="h-6" />
        {/* <button className="text-grey-60 hover:text-grey-90 transition" onClick={() => openModal('SearchModal')}>
          <Icon className="size-5" name="interface/search" />
        </button> */}
      </div>
      <div className="overflow-auto wd:h-[calc(100vh_-_4rem)] no-scrollbar">
        <ActiveLink
          to="/liquidity"
          className="mx-2 mb-2 flex items-center rounded-md px-4 py-2 text-grey-60 hover:text-brand-50"
          activeClassName="bg-bg-l1 !text-brand-50"
        >
          <Icon className="mr-2 size-4" name="interface/deposit" />
          <span className="text-caption-13">Liquidity</span>
        </ActiveLink>
        <LiveSwitcher />
        <Navigation className="mt-2" />
      </div>
    </div>
  )
}

export default LeftSidebar
